export const BUSINESS_ALIAS = "BUSINESS_ALIAS";
export const BUSINESS_FACTORINGS = "BUSINESS_FACTORINGS";
